import { G } from "../../constants/theme";

export default function SR({ p, v }) {
  return (
    <tr>
      <td
        style={{
          padding: "15px 22px",
          fontFamily: "monospace",
          fontSize: 13,
          color: G.muted,
          borderBottom: `1px solid ${G.border}`,
          background: G.card,
          width: "55%",
        }}
      >
        {p}
      </td>
      <td
        style={{
          padding: "15px 22px",
          fontFamily: "monospace",
          fontSize: 13,
          color: G.white,
          fontWeight: 700,
          borderBottom: `1px solid ${G.border}`,
          background: G.card,
        }}
      >
        {v}
      </td>
    </tr>
  );
}
